$(document).ready(function () {

  $('.single-product__details .product-form__input__container').each(function() {
    var $container = $(this);
    var labelCount = $container.find('label').length;

    if (labelCount > 3) {
      $container.addClass('more-than-3');
    }
  });
});


$(document).ready(function() {
  $('#product-form__input__toggle').on('change', function() {
    $(this).closest('.sticky-add-cart-variant-selects')
           .find('.product-form__input__container')
           .slideToggle(200); 
  });
});



